export default __webpack_public_path__ + "static/media/013.82b806a2.jpg";